import HeaderBreadcrumb from "../components/HeaderBreadcrumb";
import {Alert, Box, Button, Stack, styled, TextField, Typography} from "@mui/material";
import MuiGrid from "@mui/material/Grid";
import axios from "axios";
import {useState} from "react";
import {MAX_CONTENT_WIDTH, MIN_CONTENT_WIDTH} from "../components/utils/Constants";

const SubmitButton = styled(Button)(({theme}) => ({
    backgroundColor: theme.palette.contrastGrey.main,
    color: '#000',
    textTransform: 'none',
    "&:hover": {
        backgroundColor: theme.palette.contrastGrey.dark,
        color: '#fff',
    },
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
}));

const Label = styled(Typography)(({theme}) => ({
    fontWeight: theme.typography.fontWeightBold,
}));

const Grid = styled(MuiGrid)(({theme}) => ({
    borderTop: "1px solid rgba(0,0,0,0.1)",
    [theme.breakpoints.up('xs')]: {
        maxWidth: MIN_CONTENT_WIDTH,
        padding: '1rem 1rem 0 1rem',
    },
    [theme.breakpoints.up('md')]: {
        maxWidth: MAX_CONTENT_WIDTH,
        padding: '2rem 4rem 0 4rem',
    }
}));

const FormGrid = styled(MuiGrid)(() => ({
    alignItems: 'center',
    justifyContent: 'flex-start',
}));

const ResetPassword = () => {
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();

        const formData = new FormData(event.currentTarget);
        const email = formData.get("email").toLowerCase();

        const resetPasswordData = new FormData();
        resetPasswordData.append("email", email);

        axios.post("/auth/resetPassword", resetPasswordData)
            .then((response) => {
                setSuccessMessage(response.data);
                setErrorMessage("");
            })
            .catch((error) => {
                setSuccessMessage("");
                setErrorMessage(error.response.data);
            });
    };

    return (
        <Stack>
            <HeaderBreadcrumb name="Reset Password" color="admin"/>
            <Stack sx={{alignItems: "center"}}>
                <Grid container spacing={{xs: 0, md: 2}} columns={{xs: 1, md: 12}}>
                    <Stack spacing={2}>
                        {successMessage.length > 0 && (<Alert severity="success">{successMessage}</Alert>)}
                        {errorMessage.length > 0 && (<Alert severity="error">{errorMessage}</Alert>)}

                        <Box component="form" onSubmit={handleSubmit}>
                            <FormGrid container spacing={{xs: 1, md: 2}} columns={{xs: 1, md: 12}}>
                                <Label>Email Address</Label>
                                <TextField
                                    id="email"
                                    name="email"
                                    type="email"
                                    size="small"
                                    required
                                    slotProps={{
                                        htmlInput: {
                                            size: 50
                                        }
                                    }}
                                />
                                <SubmitButton type="submit" variant="contained">Reset Password</SubmitButton>
                            </FormGrid>
                        </Box>

                        <Typography>
                            If you have forgotten or need to reset your password, input your email address above and click 'Reset Password'.
                            A new password will be generated and emailed to you.
                        </Typography>
                    </Stack>
                </Grid>
            </Stack>
        </Stack>
    );
};

export default ResetPassword;
